<div class="ppl-container-body" style="margin-top: -10px">
    <div class="ppl-container">
        <div class="ppl-content-container">
            <div class="w-100">
                <div class="custom-row">
                    <ppl-button label="Download Service Adjust Template" icon="fa fa-download"
                        [customClass]="'primary-button'" [iconPosition]="'left'"
                        (click)="onDownload('service')"></ppl-button>
                    <ppl-button label="Download MCO Adjust Template" icon="fa fa-download"
                        [customClass]="'primary-button'" [iconPosition]="'left'" (click)="onDownload('mco')"
                        style="margin: 0 2px 0 4px;"></ppl-button>
                    <nz-upload [nzShowUploadList]="false" [nzCustomRequest]="customRequest"
                        style="margin: 0 4px 0 2px;">
                        <ppl-button label="Bulk Service Adjust Upload" icon="fa fa-upload"
                            [customClass]="'primary-button'" [iconPosition]="'left'"
                            (click)="onUpload('service')"></ppl-button>
                    </nz-upload>
                    <nz-upload [nzShowUploadList]="false" [nzCustomRequest]="customRequest">
                        <ppl-button label="Bulk MCO Adjust Upload" icon="fa fa-upload" [customClass]="'primary-button'"
                            [iconPosition]="'left'" (click)="onUpload('MCO')"></ppl-button>
                    </nz-upload>
                </div>
            </div>
            <div class="w-100">
                <ppl-claim-adjustment-filter (searchEvent)="onSearch($event)" (refreshEvent)="onRefresh($event)" [filterFields]="fields"
                    [adjustType]="'bulk'"></ppl-claim-adjustment-filter>

            </div>
            <div class="table-style">
                <ppl-list-table [customDataLoaded]="true" [disableSearch]="true" [showCustomSearch]="false"
                    [cols]="cols" [enableActions]="false" [data]="bulkClaimData" [disableSelection]="true"
                    [gridTitle]="false" [pagination]="true" [loadPage]="true" (rowDetailEventTs)="rowActions($event)"
                    [from]="'claimAdj'">
                </ppl-list-table>
            </div>
        </div>
    </div>
</div>

<div class="filter-panel">
    <ng-template #batchDetailsDialog let-cancel="cancel">
        <div class="pl-4 pr-4 mt-2">
            <ppl-list-table [disableSearch]="true" [showCustomSearch]="false" [disableSelection]="true"
                [cols]="batchCols" [data]="batchData" (rowDetailEventTs)="rowActions($event)"
                [from]="'claimAdj'"></ppl-list-table>
        </div>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #claimTimesheetDetailsDialog let-cancel="cancel">
        <ppl-view-claim-timesheets [claimTSData]="claimTSData" [errorCode]="errorCode"></ppl-view-claim-timesheets>
    </ng-template>
</div>